<template>
  <div class="printBox page3 common">
    <div class="bg-t"></div>
    <div class="content">
      <div style="color: #0066CC;">
        <div style="font-size: 32px;">四、整体预警情况</div>
      </div>
      <div class="chart-content">
        <div class="chartBox">
          <div class="title">1、综合预警情况</div>
          <div class="chart1" ref="chartRef1" style="width: 100%;height: 100%;">
            
          </div>
        </div>
        <div class="chartBox">
          <div class="title">2、身心健康预警</div>
          <div class="chart2" ref="chartRef2" style="width: 100%;height: 100%;">
            
          </div>
        </div>
        <div class="chartBox">
          <div class="title">3、心理状态预警</div>
          <div class="chart3" ref="chartRef3" style="width: 100%;height: 100%;">
            
          </div>
        </div>
      </div>
    </div>
    <div class="bg-b"></div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import * as echarts from "echarts";

const props = defineProps(["data"]);

const chartRef1 = ref(null);
const chartRef2 = ref(null);
const chartRef3 = ref(null);
let chartInstance1 = null;
let chartInstance2 = null;
let chartInstance3 = null;

const init = () => {
  chartInstance1 = echarts.init(chartRef1.value);
  chartInstance2 = echarts.init(chartRef2.value);
  chartInstance3 = echarts.init(chartRef3.value);
};

onMounted(() => {
  nextTick(() => {
    init();
  })
});

watch(
  () => props.data,
  (val) => {
    setChart1(val.comprehensiveResultList);
    setChart2(val.comprResultList);
    setChart3(val.mshasResultList);
  },
  { deep: true }
);

const setChart1 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '综合预警情况图',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: '0',
      top: 'middle',
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        label: {
          fontSize: 12,
          formatter: ({ name, percent, value }) => {
            return `${name}\n人数：${value}\n占比 ${percent.toFixed(2)}%`;
          }
        },
        data: val.map((item) => {
          return {
            name: item.result,
            value: item.peopleData.numberPeople,
          }
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
  chartInstance1 && chartInstance1.setOption(option);
}
const setChart2 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '身心健康预警图',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: '0',
      top: 'middle',
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        label: {
          fontSize: 12,
          formatter: ({ name, percent, value }) => {
            return `${name}\n人数：${value}\n占比 ${percent.toFixed(2)}%`;
          }
        },
        data: val.map((item) => {
          return {
            name: item.result,
            value: item.peopleData.numberPeople,
          }
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
  chartInstance2 && chartInstance2.setOption(option);
}
const setChart3 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '心理状态预警图',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: '0',
      top: 'middle',
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        label: {
          fontSize: 12,
          formatter: ({ name, percent, value }) => {
            return `${name}\n人数：${value}\n占比 ${percent.toFixed(2)}%`;
          }
        },
        data: val.map((item) => {
          return {
            name: item.result,
            value: item.peopleData.numberPeople,
          }
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
  chartInstance3 && chartInstance3.setOption(option);
}
</script>

<style lang="scss" scoped>
.page3{
  position: relative;
}
.page3 .title{
  font-size: 24px;
  color: #0066CC;
}
.page3 .content{
  padding: 40px;
  height: 100%;
}
.page3 .chart-content{
  padding: 20px;
  height: 100%;
  display: grid;
  grid-template-rows: repeat(3,1fr);
}
.page3 .chartBox{
  display: grid;
  grid-template-rows: auto 1fr;
}
.page3 .bg-t{
  position: absolute;
  top: 0;
  right: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-rt.png") no-repeat;
  background-size: 100% 100%;
}
.page3 .bg-b{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-lb.png") no-repeat;
  background-size: 100% 100%;
}
</style>